/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

enum ActionTypes {
  // Reset reducer
  RESET_STATE = 'gfm/practicas/RESET_STATE',
  // Set reducer
  SET_CURSOS_PRACTICA = 'gfm/practicas/SET_CURSOS_PRACTICA',
  SET_FORMADOR_CURSO = 'gfm/practicas/SET_FORMADOR_CURSO',
  SET_ALUMNOS_PRACTICA = 'gfm/practicas/SET_ALUMNOS_PRACTICA',
  SET_ESTADOS_CURSOS = 'gfm/practicas/SET_ESTADOS_CURSOS',
  SET_FECHA_MINIMA_PRACTICA = 'gfm/practicas/SET_FECHA_MINIMA_PRACTICA',
  SET_FECHA_MAXIMA_PRACTICA = 'gfm/practicas/SET_FECHA_MAXIMA_PRACTICA',
  SET_SORTING = 'gfm/practicas/SET_ORDER',
  SET_SORTING_SORT = 'gfm/practicas/SET_SORTING_SORT',
  SET_SORT = 'gfm/practicas/SET_SORT',
  RESET_SORT = 'gfm/practicas/RESET_SORT',
  SUBMIT_FILTERS = 'gfm/practicas/SUBMIT_FILTERS',
  SET_PRACTICAS_SELECCIONADA = 'gfm/practicas/SET_PRACTICAS_SELECCIONADA',
  SET_CURSOS_ACTIVOS_JORNADA = 'gfm/practicas/SET_CURSOS_ACTIVOS_JORNADA',
  SET_INSTRUCTORES_PRACTICAS = 'gfm/practicas/SET_INSTRUCTORES_PRACTICAS',
  SET_INSTRUCTORES = 'gfm/practicas/SET_INSTRUCTORES',
  SET_PRACTICAS_COUNT = 'gfm/practicas/SET_PRACTICAS_COUNT',
  SET_PRACTICAS_AUDITORIA_COUNT = 'gfm/practicas/SET_PRACTICAS_AUDITORIA_COUNT',
  SET_PRACTICAS = 'gfm/practicas/SET_PRACTICAS',
  SET_PRACTICAS_BY_JORNADA = 'gfm/practicas/SET_PRACTICAS_BY_JORNADA',
  SET_PRACTICAS_AUDITORIA = 'gfm/practicas/SET_PRACTICAS_AUDITORIA',
  SET_TODAS_PRACTICAS_AUDITORIA = 'gfm/practicas/SET_TODAS_PRACTICAS_AUDITORIA',
  SET_PRACTICAS_FILTER = 'gfm/practicas/SET_PRACTICAS_FILTER',
  SET_ESTADOS_PRACTICA = 'gfm/practicas/SET_ESTADOS_PRACTICA',
  SET_TIPOS_SERVICIO = 'gfm/practicas/SET_TIPOS_SERVICIO',
  SET_SOCIEDADES = 'gfm/practicas/SET_SOCIEDADES',
  SET_JORNADAS_USUARIO = 'gfm/practicas/SET_JORNADAS_USUARIO',
  SET_ESTACIONES = 'gfm/practicas/SET_ESTACIONES',
  SET_TIPOS_PRACTICA = 'gfm/practicas/SET_TIPOS_PRACTICA',
  SET_PROVINCIAS = 'gfm/practicas/SET_PROVINCIAS',
  SET_PAGES = 'gfm/practicas/SET_PAGES',
  SET_SELECTED_PAGE = 'gfm/practicas/SET_SELECTED_PAGE',
  SET_ELEMENTS_PER_PAGE = 'gfm/practicas/SET_ELEMENTS_PER_PAGE',
  SET_CURSOS_AUDITORIA = 'gfm/practicas/SET_CURSOS_AUDITORIA',
  SET_SELECTED_CURSOS_AUDITORIA = 'gfm/practicas/SET_SELECTED_CURSOS_AUDITORIA',
  SET_SELECTED_SOCIEDAD_AUDITORIA = 'gfm/practicas/SET_SELECTED_SOCIEDAD_AUDITORIA',
  SET_SELECTED_PROVINCIA_AUDITORIA = 'gfm/practicas/SET_SELECTED_PROVINCIA_AUDITORIA',
  SET_PROVINCIAS_AUDITORIA = 'gfm/practicas/SET_PROVINCIAS_AUDITORIA',
  SET_ALUMNOS_AUDITORIA = 'gfm/practicas/SET_ALUMNOS_AUDITORIA',
  SET_USER_INFO = 'gfm/practicas/SET_USER_INFO',
  EXPORT_EXCEL = 'gfm/practicas/EXPORT_EXCEL',

  // Remove
  REMOVE_SELECTED_PROVINCIAS_AUDITORIA = 'gfm/practicas/REMOVE_SELECTED_PROVINCIAS_AUDITORIA',
  REMOVE_SELECTED_CURSOS_AUDITORIA = 'gfm/practicas/REMOVE_SELECTED_CURSOS_AUDITORIA',
  REMOVE_FILTER_AUDITORIA = 'gfm/practicas/REMOVE_FILTER_AUDITORIA',

  // Requests
  POST_ANULAR_PRACTICA_REQUEST = 'gfm/practicas/POST_ANULAR_PRACTICA_REQUEST',
  POST_AUDITORIA_REQUEST = 'gfm/practicas/POST_AUDITORIA_REQUEST',
  POST_AUDITORIA_EDIT_REQUEST = 'gfm/practicas/POST_AUDITORIA_EDIT_REQUEST',
  POST_RECHAZAR_PRACTICA_REQUEST = 'gfm/practicas/POST_RECHAZAR_PRACTICA_REQUEST',
  POST_RECHAZAR_PRACTICA_EDIT_REQUEST = 'gfm/practicas/POST_RECHAZAR_PRACTICA_EDIT_REQUEST',
  POST_RECLAMAR_PRACTICA_REQUEST = 'gfm/practicas/POST_RECLAMAR_PRACTICA_REQUEST',
  POST_VALIDAR_PRACTICA_REQUEST = 'gfm/practicas/POST_VALIDAR_PRACTICA_REQUEST',
  GET_FILTER_CURSO_PRACTICA_REQUEST = 'gfm/practicas/GET_FILTER_CURSO_PRACTICA_REQUEST',
  GET_FORMADOR_CURSO_REQUEST = 'gfm/practicas/GET_FORMADOR_CURSO_REQUEST',
  GET_FILTER_ALUMNO_PRACTICA_REQUEST = 'gfm/practicas/GET_FILTER_ALUMNO_PRACTICA_REQUEST',
  GET_FILTER_CURSOS_BY_INSTRUCTORES_REQUEST = 'gfm/practicas/GET_FILTER_CURSOS_BY_INSTRUCTORES_REQUEST',
  GET_FILTER_CURSOS_BY_ALUMNOS_REQUEST = 'gfm/practicas/GET_FILTER_CURSOS_BY_ALUMNOS_REQUEST',
  GET_FILTER_CURSOS_BY_ALUMNOS_AUDITORIA_REQUEST = 'gfm/practicas/GET_FILTER_CURSOS_BY_ALUMNOS_AUDITORIA_REQUEST',
  GET_FILTER_INSTRUCTORES_BY_ALUMNOS_REQUEST = 'gfm/practicas/GET_FILTER_INSTRUCTORES_BY_ALUMNOS_REQUEST',
  GET_FILTER_ALUMNOS_BY_INSTRUCTORES_REQUEST= 'gfm/practicas/GET_FILTER_ALUMNOS_BY_INSTRUCTORES_REQUEST',
  GET_ESTADOS_CURSOS_REQUEST = 'gfm/practicas/GET_ESTADOS_CURSOS_REQUEST',
  GET_FECHA_MINIMA_PRACTICA_REQUEST = 'gfm/practicas/GET_FECHA_MINIMA_PRACTICA_REQUEST',
  GET_FECHA_MAXIMA_PRACTICA_REQUEST = 'gfm/practicas/GET_FECHA_MAXIMA_PRACTICA_REQUEST',
  GET_PRACTICAS_SELECCIONADA_REQUEST = 'gfm/practicas/GET_PRACTICAS_SELECCIONADA_REQUEST',
  GET_CURSOS_ACTIVOS_JORNADA_REQUEST = 'gfm/practicas/GET_CURSOS_ACTIVOS_JORNADA_REQUEST',
  GET_INSTRUCTORES_PRACTICAS_REQUEST = 'gfm/practicas/GET_INSTRUCTORES_PRACTICAS_REQUEST',
  CREAR_PRACTICA_REQUEST = 'gfm/practicas/CREAR_PRACTICA_REQUEST',
  GET_PRACTICAS_COUNT_REQUEST = 'gfm/practicas/GET_PRACTICAS_COUNT_REQUEST',
  GET_PRACTICAS_AUDITORIA_COUNT_REQUEST = 'gfm/practicas/GET_PRACTICAS_AUDITORIA_COUNT_REQUEST',
  GET_PRACTICAS_REQUEST = 'gfm/practicas/GET_PRACTICAS_REQUEST',
  GET_PRACTICAS_BY_JORNADA_REQUEST = 'gfm/practicas/GET_PRACTICAS_BY_JORNADA_REQUEST',
  GET_PRACTICAS_AUDITORIA_REQUEST = 'gfm/practicas/GET_PRACTICAS_AUDITORIA_REQUEST',
  GET_TODAS_PRACTICAS_AUDITORIA_RREQUEST = 'gfm/practicas/GET_TODAS_PRACTICAS_AUDITORIA',
  GET_ESTADOS_PRACTICA_REQUEST = 'gfm/practicas/GET_ESTADOS_PRACTICA_REQUEST',
  GET_TIPO_SERVICIO_REQUEST = 'gfm/practicas/GET_TIPO_SERVICIO_REQUEST',
  GET_SOCIEDADES_REQUEST = 'gfm/practicas/GET_SOCIEDADES_REQUEST',
  GET_JORNADAS_USUARIO_REQUEST = 'gfm/practicas/GET_JORNADAS_USUARIO_REQUEST',
  GET_ESTACIONES_REQUEST = 'gfm/practicas/GET_ESTACIONES_REQUEST',
  GET_TIPOS_PRACTICA_REQUEST = 'gfm/practicas/GET_TIPOS_PRACTICA_REQUEST',
  GET_PROVINCIAS_REQUEST = 'gfm/practicas/GET_PROVINCIAS_REQUEST',
  GET_CURSO_AUDITORIA_REQUEST = 'gfm/practicas/GET_CURSO_AUDITORIA_REQUEST',
  GET_ALUMNOS_AUDITORIA_REQUEST = 'gfm/practicas/GET_ALUMNOS_AUDITORIA_REQUEST',

  // Requests status
  SET_POST_ANULAR_PRACTICA_REQUEST_STATUS = 'gfm/practicas/SET_POST_ANULAR_PRACTICA_REQUEST_STATUS',
  SET_POST_AUDITORIA_REQUEST_STATUS = 'gfm/practicas/SET_POST_AUDITORIA_REQUEST_STATUS',
  SET_POST_RECHAZAR_PRACTICA_REQUEST_STATUS = 'gfm/practicas/SET_POST_RECHAZAR_PRACTICA_REQUEST_STATUS',
  SET_POST_RECLAMAR_PRACTICA_REQUEST_STATUS = 'gfm/practicas/SET_POST_RECLAMAR_PRACTICA_REQUEST_STATUS',
  SET_POST_VALIDAR_PRACTICA_REQUEST_STATUS = 'gfm/practicas/SET_POST_VALIDAR_PRACTICA_REQUEST_STATUS',
  SET_GET_FILTER_CURSO_PRACTICA_REQUEST_STATUS = 'gfm/practicas/SET_GET_FILTER_CURSO_PRACTICA_REQUEST_STATUS',
  SET_GET_FORMADOR_CURSO_REQUEST_STATUS = 'gfm/practicas/SET_GET_FORMADOR_CURSO_REQUEST_STATUS',
  SET_GET_FILTER_ALUMNO_PRACTICA_REQUEST_STATUS = 'gfm/practicas/SET_GET_FILTER_ALUMNO_PRACTICA_REQUEST_STATUS',
  SET_GET_FILTER_CURSOS_BY_INSTRUCTORES_REQUEST_STATUS = 'gfm/practicas/SET_GET_FILTER_CURSOS_BY_INSTRUCTORES_REQUEST_STATUS',
  SET_GET_FILTER_CURSOS_BY_ALUMNOS_REQUEST_STATUS = 'gfm/practicas/SET_GET_FILTER_CURSOS_BY_ALUMNOS_REQUEST_STATUS',
  SET_GET_FILTER_INSTRUCTORES_BY_ALUMNOS_REQUEST_STATUS = 'gfm/practicas/SET_GET_FILTER_INSTRUCTORES_BY_ALUMNOS_REQUEST_STATUS',
  SET_GET_FILTER_ALUMNOS_BY_INSTRUCTORES_REQUEST_STATUS = 'gfm/practicas/SET_GET_FILTER_ALUMNOS_BY_INSTRUCTORES_REQUEST_STATUS',
  SET_GET_ESTADOS_CURSOS_REQUEST_STATUS = 'gfm/practicas/SET_GET_ESTADOS_CURSOS_REQUEST_STATUS',
  SET_GET_FECHA_MINIMA_PRACTICA_REQUEST_STATUS = 'gfm/practicas/SET_GET_FECHA_MINIMA_PRACTICA_REQUEST_STATUS',
  SET_GET_FECHA_MAXIMA_PRACTICA_REQUEST_STATUS = 'gfm/practicas/SET_GET_FECHA_MAXIMA_PRACTICA_REQUEST_STATUS',
  SET_GET_PRACTICAS_SELECCIONADA_REQUEST_STATUS = 'gfm/practicas/SET_GET_PRACTICAS_SELECCIONADA_REQUEST_STATUS',
  SET_GET_CURSOS_ACTIVOS_JORNADA_REQUEST_STATUS = 'gfm/practicas/SET_GET_CURSOS_ACTIVOS_JORNADA_REQUEST_STATUS',
  SET_GET_INSTRUCTORES_PRACTICAS_REQUEST_STATUS = 'gfm/practicas/SET_GET_INSTRUCTORES_PRACTICAS_REQUEST_STATUS',
  SET_CREAR_PRACTICA_REQUEST_STATUS = 'gfm/practicas/SET_CREAR_PRACTICA_REQUEST_STATUS',
  SET_GET_PRACTICAS_COUNT_REQUEST_STATUS = 'gfm/practicas/SET_GET_PRACTICAS_COUNT_REQUEST_STATUS',
  SET_GET_PRACTICAS_REQUEST_STATUS = 'gfm/practicas/SET_GET_PRACTICAS_REQUEST_STATUS',
  SET_GET_PRACTICAS_BY_JORNADA_REQUEST_STATUS = 'gfm/practicas/SET_GET_PRACTICAS_BY_JORNADA_REQUEST_STATUS',
  SET_GET_PRACTICAS_REQUEST_STATUS_LOADING = 'gfm/practicas/SET_GET_PRACTICAS_REQUEST_STATUS_LOADING',
  SET_GET_PRACTICAS_UPDATE = 'gfm/practicas/SET_GET_PRACTICAS_UPDATE',
  SET_GET_PRACTICAS_AUDITORIA_UPDATE = 'gfm/practicas/SET_GET_PRACTICAS_AUDITORIA_UPDATE',
  SET_GET_PRACTICAS_AUDITORIA_REQUEST_STATUS = 'gfm/practicas/SET_GET_PRACTICAS_AUDITORIA_REQUEST_STATUS',
  SET_GET_AUDIT_PRACTICES_REQUEST_STATUS_LOADING = 'gfm/practicas/SET_GET_AUDIT_PRACTICES_REQUEST_STATUS_LOADING',
  SET_GET_ESTADOS_PRACTICA_REQUEST_STATUS = 'gfm/practicas/SET_GET_ESTADOS_PRACTICA_REQUEST_STATUS',
  SET_GET_TIPO_SERVICIO_REQUEST_STATUS = 'gfm/practicas/SET_GET_TIPO_SERVICIO_REQUEST_STATUS',
  SET_GET_SOCIEDADES_REQUEST_STATUS = 'gfm/practicas/SET_GET_SOCIEDADES_REQUEST_STATUS',
  SET_GET_JORNADAS_USUARIO_REQUEST_STATUS = 'gfm/practicas/SET_GET_JORNADAS_USUARIO_REQUEST_STATUS',
  SET_GET_ESTACIONES_REQUEST_STATUS = 'gfm/practicas/SET_GET_ESTACIONES_REQUEST_STATUS',
  SET_GET_TIPOS_PRACTICA_REQUEST_STATUS = 'gfm/practicas/SET_GET_TIPOS_PRACTICA_REQUEST_STATUS',
  SET_GET_PROVINCIAS_REQUEST_STATUS = 'gfm/practicas/SET_GET_PROVINCIAS_REQUEST_STATUS',
  SET_GET_CURSOS_AUDITORIA_REQUEST_STATUS = 'gfm/practicas/SET_GET_CURSOS_AUDITORIA_REQUEST_STATUS',
  SET_GET_ALUMNOS_AUDITORIA_REQUEST_STATUS = 'gfm/practicas/SET_GET_ALUMNOS_AUDITORIA_REQUEST_STATUS',
  SET_GET_INFO_USERS_REQUEST_STATUS = 'gfm/usuarios/SET_GET_INFO_USERS_REQUEST_STATUS',
  RESET_PRACTICA_SELECCIONADA = 'gfm/practicas/RESET_PRACTICA_SELECCIONADA',

  RESET_PRACTICAS_BY_JORNADA = 'gfm/practicas/RESET_PRACTICAS_BY_JORNADA',

  GET_PRACTICAS = 'gfm/practicas/GET_PRACTICAS',
  SET_PRACTICAS_2 = 'gfm/practicas/SET_PRACTICAS_2',
  GET_PRACTICAS_COUNT = 'gfm/practicas/GET_PRACTICAS_COUNT',
  SET_PRACTICAS_COUNT_2 = 'gfm/practicas/SET_PRACTICAS_COUNT_2',
  GET_PRACTICAS_EXCEL = 'gfm/practicas/GET_PRACTICAS_EXCEL',
  GET_PRACTICAS_HORAS_FORMACION_INSTRUCTOR_EXCEL = 'gfm/practicas/GET_PRACTICAS_HORAS_FORMACION_INSTRUCTOR_EXCEL',
  REMOVE_PRACTICAS_FILTER = 'gfm/practicas/REMOVE_PRACTICAS_FILTER',

  //Filtros
  SET_FILTROS = 'gfm/practicas/SET_FILTROS',
}

export default ActionTypes;
